import connection from '../assets/icons/aboutrpa/connection.png'
import copy from '../assets/icons/aboutrpa/copy.png'
import folder from '../assets/icons/aboutrpa/folder.png'
import mail from '../assets/icons/aboutrpa/mail.png'
import file from '../assets/icons/aboutrpa/file.png'
import calculation from '../assets/icons/aboutrpa/calculation.png'

const data = [
    {
        id: 1,
        img: connection,
        para: 'Connecting to apps and systems'
    },

    {
        id: 1,
        img: copy,
        para: 'Copying and pasting data'
    },

    {
        id: 3,
        img: folder,
        para: 'Moving files and folders'
    },

    {
        id: 4,
        img: mail,
        para: 'Opening emails and attachments'
    },

    {
        id: 5,
        img: file,
        para: 'Extracting and processing content from documents, emails and forms'
    },

    {
        id: 6,
        img: calculation,
        para: 'Making calculations'
    },
]
export default data;